import BaseModal from './BaseModal';

export type { IBaseModalProps } from './BaseModal.types';
export default BaseModal;
